import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { Hero } from "@/components/landing/Hero";
import { HeroTopBanner } from "@/components/landing/HeroTopBanner";
import { FamilyTreeSampleTemplates } from "@/components/landing/FamilyTreeSampleTemplates";
import { CtaFooter } from "@/components/landing/CtaFooter";
import { MobileStickyCta } from "@/components/landing/MobileStickyCta";
import { TestimonialBannerCarousel } from "@/components/landing/TestimonialBannerCarousel";
import { TryDemoTree } from "@/components/landing/TryDemoTree";
import { WhatWillHappen } from "@/components/landing/WhatWillHappen";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { WhyFamiliesChooseUs } from "@/components/landing/WhyFamiliesChooseUs";
import { StoryIntro } from "@/components/landing/LandingPdfSections";
import { LegacyQuotesBand } from "@/components/landing/LegacyQuotesBand";
import { WelcomeDisclaimerModal } from "@/components/landing/WelcomeDisclaimerModal";
import AskFRBubble from "@/components/AskFRBubble";

/**
 * Landing page — mapped 1:1 to the user's "Home Page" reference PDF:
 *   Hero → Every Family Has a Story → The Process (5 steps) → Try demo tree →
 *   3 benefits → One home for everything → A cautionary tale → Testimonials → Footer.
 */
export default function Landing() {
    const location = useLocation();
    useEffect(() => {
        if (!location.hash) return;
        const el = document.getElementById(location.hash.slice(1));
        if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    }, [location.hash, location.key]);
    return (
        <div className="min-h-screen bg-white text-left" data-testid="landing-page">
            <LandingHeader />
            <HeroTopBanner />
            <main>
                <Hero />
                <StoryIntro />
                <HowItWorks />
                <TryDemoTree />
                <WhyFamiliesChooseUs />
                <FamilyTreeSampleTemplates />
                <WhatWillHappen />
                <TestimonialBannerCarousel />
                <LegacyQuotesBand />
                <CtaFooter />
            </main>
            <MobileStickyCta />
            <AskFRBubble />
            <WelcomeDisclaimerModal />
        </div>
    );
}
